import React from "react";
import { useParams, Link } from "react-router-dom";
import { FaCalendarAlt, FaArrowLeft } from "react-icons/fa";
import "./BlogDetails.css";

// All 6 blogs with enhanced content
const blogs = [
  {
    id: 1,
    title: "Top 10 Places to Visit in Hyderabad",
    description: "Discover the must-visit attractions in Hyderabad, from Charminar to Ramoji Film City.",
    image: "https://images.unsplash.com/photo-1603262110263-fb0112e7cc33",
    date: "Aug 28, 2025",
    content: [
      { type: "paragraph", text: "Hyderabad, the city of pearls, offers an amazing mix of history, culture, and modernity." },
      { type: "paragraph", text: "Visit iconic spots such as Charminar, Golconda Fort, and Ramoji Film City." },
      { type: "paragraph", text: "Don't forget to try the local cuisine like Hyderabadi Biryani and Irani Chai." },
      { type: "heading", text: "Must-Visit Attractions" },
      { type: "list", items: ["Charminar", "Golconda Fort", "Ramoji Film City", "Hussain Sagar Lake", "Salar Jung Museum"] },
      { type: "paragraph", text: "Hyderabad is also famous for its rich history, architecture, and vibrant markets." },
      { type: "quote", text: "Traveling leaves you speechless, then turns you into a storyteller." },
      { type: "image", src: "https://images.unsplash.com/photo-1603071669682-ccf98bc987af", alt: "Hyderabad city view" },
    ],
  },
  {
    id: 2,
    title: "Why Choose Cab Rentals in Hyderabad?",
    description: "Explore the benefits of choosing cab and bus rentals in Hyderabad for comfortable journeys.",
    image: "https://siddhivinayakabs.com/wp-content/uploads/2024/06/hourly-rental-cabs-vizagcabservices.jpg",
    date: "Aug 21, 2025",
    content: [
      { type: "paragraph", text: "Cab rentals provide convenience and flexibility when exploring Hyderabad." },
      { type: "paragraph", text: "They save time and make group travel stress-free." },
      { type: "heading", text: "Benefits of Cab Rentals" },
      { type: "list", items: ["Comfortable travel", "Flexible timings", "Multiple car options", "Safe and reliable drivers"] },
      { type: "quote", text: "Life is short and the world is wide. Travel responsibly." },
      { type: "image", src: "https://images.unsplash.com/photo-1595422924268-8b9a3f8a4b27", alt: "Cab in Hyderabad" },
    ],
  },
  {
    id: 3,
    title: "Best Weekend Getaways from Hyderabad",
    description: "Planning a quick escape from the city? Check out these amazing weekend getaway spots.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRS2NTrn_vjbKYgoF9vbHaYThOCvyVlT2zhug&s",
    date: "Aug 10, 2025",
    content: [
      { type: "paragraph", text: "Hyderabad has many beautiful spots for a weekend getaway." },
      { type: "list", items: ["Nagarjuna Sagar", "Srisailam", "Bidar", "Hampi", "Warangal"] },
      { type: "paragraph", text: "Perfect for a short drive with friends or family." },
      { type: "quote", text: "The journey, not the destination, matters." },
      { type: "image", src: "https://images.unsplash.com/photo-1506744038136-46273834b3fb", alt: "Weekend getaway" },
    ],
  },
  {
    id: 4,
    title: "Affordable Tempo Traveller Rentals in Hyderabad",
    description: "Traveling with a group? Tempo Traveller rentals in Hyderabad are perfect for budget-friendly journeys.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRY8DcqwFGoeEQLzdD9DQaCTR53CKOodiJqwA&s",
    date: "July 29, 2025",
    content: [
      { type: "paragraph", text: "Tempo Travellers are ideal for group travel with comfort." },
      { type: "paragraph", text: "You can book for city trips, airport transfers, or long journeys." },
      { type: "list", items: ["Spacious seating", "Air conditioning", "Affordable rates", "Professional drivers"] },
      { type: "quote", text: "Traveling together creates memories that last forever." },
      { type: "image", src: "https://images.unsplash.com/photo-1576675786814-0ee95839a0b6", alt: "Tempo Traveller" },
    ],
  },
  {
    id: 5,
    title: "Tips for Hassle-Free Bus Rentals in Hyderabad",
    description: "From choosing the right bus size to understanding rental policies, here’s everything you need to know.",
    image: "https://minibusrentinhyderabad.com/wp-content/uploads/2024/02/2018040958271_Executive-LX-Coach2-2.jpg",
    date: "July 15, 2025",
    content: [
      { type: "paragraph", text: "Bus rentals require some planning for a smooth journey." },
      { type: "list", items: ["Choose the right bus size", "Check company policies", "Confirm timings and fares", "Ensure safety standards"] },
      { type: "quote", text: "Good planning ensures a happy journey." },
      { type: "image", src: "https://images.unsplash.com/photo-1582719478146-fd80b9b8f85f", alt: "Bus rental" },
    ],
  },
  {
    id: 6,
    title: "Hyderabad Airport Transfers Made Easy",
    description: "Book reliable cab rentals for Hyderabad airport transfers for on-time pickups and drop-offs.",
    image: "https://images.unsplash.com/photo-1529070538774-1843cb3265df",
    date: "July 2, 2025",
    content: [
      { type: "paragraph", text: "Airport transfers are convenient with reliable cab services." },
      { type: "paragraph", text: "Avoid last-minute stress with pre-booked cabs." },
      { type: "list", items: ["On-time pickups", "Professional drivers", "Comfortable cars", "Affordable rates"] },
      { type: "quote", text: "Your journey starts the moment you step into the cab." },
      { type: "image", src: "https://images.unsplash.com/photo-1581642200664-2c3b8e44c935", alt: "Airport transfer" },
    ],
  },
];

const BlogDetails = () => {
  const { id } = useParams();
  const blog = blogs.find(b => b.id === parseInt(id));

  if (!blog) return <div className="blog-detail-page"><h2>Blog Not Found</h2></div>;

  return (
    <div className="blog-detail-page">
      <Link to="/blogs" className="back-link"><FaArrowLeft /> Back to Blogs</Link>

      <div className="blog-detail-hero">
        <img src={blog.image} alt={blog.title} />
        <div className="blog-detail-hero-text">
          <h1>{blog.title}</h1>
          <p className="blog-detail-date"><FaCalendarAlt /> {blog.date}</p>
        </div>
      </div>

      <div className="blog-detail-content">
        {blog.content.map((section, index) => {
          switch (section.type) {
            case "paragraph":
              return <p key={index}>{section.text}</p>;
            case "heading":
              return <h2 key={index}>{section.text}</h2>;
            case "list":
              return (
                <ul key={index}>
                  {section.items.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
              );
            case "quote":
              return <blockquote key={index}>{section.text}</blockquote>;
            case "image":
              return <img key={index} src={section.src} alt={section.alt} className="blog-detail-inline-image" />;
            default:
              return null;
          }
        })}
      </div>
    </div>
  );
};

export default BlogDetails;
